import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav } from 'reactstrap';
// import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem } from 'reactstrap';
import './AppHeader.css';

class AppHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
        };

        // Bind state altering functions
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {

        return (
            <div className="AppHeader">
                <Navbar color="faded" light expand="md">
                    <NavbarBrand className="noselect">Veles</NavbarBrand>
                    <NavbarToggler onClick={this.toggle}/>

                    <Collapse isOpen={this.state.isOpen} navbar>
                        <Nav className="ml-auto" navbar>
                            {/*<NavItem>*/}
                                {/*<Link className="veles-router-link noselect" to='/home'>Home</Link>*/}
                            {/*</NavItem>*/}
                            {/*<NavItem>*/}
                                {/*<Link className="veles-router-link noselect" to='/onboard'>Onboard</Link>*/}
                            {/*</NavItem>*/}
                            {/*<NavItem>*/}
                                {/*<Link className="veles-router-link noselect" to='/analytics'>Analytics</Link>*/}
                            {/*</NavItem>*/}
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        );

    }
};

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/App/components/Header/components/AppHeader/AppHeader.js